// tokenUtils.js
const token = 'Y2UzMTlkMmUtZWU4Yy00MmRkLTk2ODEtYWIwYTRlYmM2Zjc4';
export const getToken = () => token;

